import { defineMessages } from 'react-intl';

type MessageDescriptor = {
	id: string;
	defaultMessage: string;
	description: string;
};

export const messages: {
	description: MessageDescriptor;
} = defineMessages({
	description: {
		id: 'twg-microsite.pageErrorView.description',
		defaultMessage:
			"Looks like something's gone wrong. We're currently untangling things to get your context back on track. Refresh the page to give it another go.",
		description: 'Supporting copy shown below the Whoops graphic in the home page error fallback.',
	},
});
